import React from 'react';
import { Modal, Card, Carousel } from 'antd';

const { Meta } = Card;

interface CardData {
  key: string;
  title: string;
  description: string;
  imgSrc: string;
}

interface CylinderSelectionModalProps {
  isModalVisible: boolean;
  handleCancel: () => void;
  handleOptionSelect: (key: string) => void;
  groupedCards: CardData[][];
}

const RefillModalSelection: React.FC<CylinderSelectionModalProps> = ({
  isModalVisible,
  handleCancel,
  handleOptionSelect,
  groupedCards,
}) => {
  return (
    <Modal
      title="Choose your cylinder type"
      visible={isModalVisible}
      onCancel={handleCancel}
      footer={null}
    >
      <Carousel arrows infinite={false}>
        {groupedCards.map((group, index) => (
          <div key={index}>
            <div className="flex items-center justify-between gap-4">
              {group.map(card => (
                <Card
                  key={card.key}
                  hoverable
                  style={{ width: 240 }}
                  cover={<img alt={card.title} src={card.imgSrc} />}
                  onClick={() => handleOptionSelect(card.key)}
                >
                  <Meta title={card.title} description={card.description} />
                </Card>
              ))}
            </div>
          </div>
        ))}
      </Carousel>
    </Modal>
  );
};

export default RefillModalSelection;
